import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const applicationsDeleteActions = createActionGroup({
  source: 'Einreichung - applications delete',
  events: {
    'Delete': props<{ applicationId: string }>(),
    'Delete success': emptyProps(), // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'Delete failed': props<{ error: any }>(),
    'Clear store': emptyProps(),
  },
});
